"use client";

import { Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StarkareTillsammans() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const currentMembers = 842;
  const targetMembers = 1000;
  const progressPercentage = currentMembers / targetMembers * 100;
  return <section id="starkare-tillsammans" className="relative w-full min-h-[85vh] flex items-end py-24 lg:py-32 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/tesla_fleet_parked.png" alt="En grupp parkerade Tesla-bilar" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/60 to-black/20" />
      </div>

      {}
      <div className="container max-w-7xl mx-auto px-6 relative z-10 w-full">
        <div ref={ref} className={`max-w-2xl transition-all duration-1000 ease-out transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Starkare tillsammans
          </h1>
          
          <p className="font-sans text-lg md:text-xl text-white/90 mb-10 leading-relaxed">
            Gå med i Sveriges snabbast växande kollektiv för Tesla-ägare. Genom att samla vår gemensamma kraft förhandlar vi fram exklusiva och betydligt billigare försäkringsvillkor. Ju fler vi är, desto starkare förhandlingsposition får vi.
          </p>

          {}
          <div className="bg-black/40 backdrop-blur-md border border-white/10 rounded-xl p-6 md:p-8 mb-10 shadow-2xl">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-5">
              <div className="flex items-center gap-3">
                <div className="bg-primary/20 p-2.5 rounded-full shrink-0">
                  <Users className="w-5 h-5 text-primary" />
                </div>
                <span className="font-sans font-medium text-white text-lg">
                  Medlemmar mot nästa rabattnivå
                </span>
              </div>
              <div className="text-left sm:text-right">
                <span className="font-sans font-bold text-white text-2xl tracking-tight">
                  {currentMembers}
                </span>
                <span className="font-sans text-white/60 text-lg ml-1">
                  / {targetMembers}
                </span>
              </div>
            </div>
            
            <Progress value={progressPercentage} className="h-3 bg-white/10" />
            
            <p className="font-sans text-sm text-white/70 mt-4 text-right">
              Bara <strong className="text-white font-medium">{targetMembers - currentMembers}</strong> medlemmar kvar till nästa stora milstolpe!
            </p>
          </div>

          {}
          <Button size="lg" className="text-base px-8 py-6 rounded-md shadow-lg hover:shadow-primary/25 transition-all duration-300 w-full sm:w-auto" asChild>
            <Link to="/CheaperInsurancePage">
              Gå med i kollektivet kostnadsfritt
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}